var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ narrow: _vm.narrow }},[_c('div',{staticClass:"button",class:_vm.classes,on:{"click":_vm.onClick}},[_c('span',[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }